/* eslint-disable */
const getters = {
  getGeneral(state) {
    return {
      ...state.data,
      photoable_type: 'App\\General',
    };
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
